import type { Job } from "../types/job";
import { liveViewOf } from "./pending";

export type JobsStatusFilter = "all" | "published" | "draft";
export type JobsTriggerFilter = "schedule" | "webhook";

export interface JobsFilterState {
  query: string;
  status: JobsStatusFilter;
  /** Vazio = qualquer gatilho. */
  triggers: JobsTriggerFilter[];
}

export const EMPTY_JOBS_FILTER: JobsFilterState = { query: "", status: "all", triggers: [] };

export function isEmptyJobsFilter(filter: JobsFilterState): boolean {
  return filter.query.trim() === "" && filter.status === "all" && filter.triggers.length === 0;
}

function normalize(text: string): string {
  return text.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}

/**
 * Os jobs que passam no filtro da tela (AB#86605). A busca olha nome, descrição
 * e instrução — é na instrução que a Skill aparece, então procurar pelo nome da
 * Skill encontra os jobs que a seguem. Sem acento e sem caixa: "reuniao" acha
 * "Reunião".
 */
export function filterJobs(jobs: Job[], filter: JobsFilterState): Job[] {
  const terms = normalize(filter.query).split(/\s+/).filter(Boolean);
  return jobs.filter((job) => {
    if (filter.status === "published" && !job.published) return false;
    if (filter.status === "draft" && job.published) return false;
    // O gatilho é o que está em vigor, o mesmo que a coluna mostra (AB#87442).
    const live = liveViewOf(job);
    if (filter.triggers.length > 0 && !filter.triggers.includes(live.trigger.type)) return false;
    if (terms.length === 0) return true;
    // A busca acha tanto o que roda quanto o que está no rascunho por publicar.
    const haystack = normalize(
      [job.name, job.description, live.instruction, job.instruction].filter(Boolean).join(" "),
    );
    return terms.every((term) => haystack.includes(term));
  });
}
